import { statusTypes } from "../config/constants";
import { getStringValidationState } from "./validation";

const demographicValidation = {
  elements: {
    maritalStatus: { // Even though its a radio, we're looking for any value
      validationMethod: 'getStringValidationState',
      name: 'Marital Status',
      id: 'maritalStatus'
    }
  },
  getStringValidationState,
  getValidationStatus(demographicState) {
    let status = {
      section: {
        message: 'Section Complete',
        invalidElements: [],
        status: statusTypes.SUCCESS
      }
    };
    for (const element in this.elements) {
      const { validationMethod, id, path, name } = this.elements[element];
      let state = demographicState;
      if(path) // Path means we're not at the root of the object
        path.forEach(function(level){
          state = state[level];
        });
      const elementStatus = this[validationMethod](state, id);
      status[element] = elementStatus;
      if(elementStatus !== statusTypes.SUCCESS) {
        status.section.status = statusTypes.DANGER;
        status.section.message = 'Invalid Elements';
        status.section.invalidElements.push(name);
      }
    }
    return status;
  }
};

export default demographicValidation;